export default {"src":"/_next/static/media/product.fd882ac3.svg","height":532,"width":798,"blurWidth":0,"blurHeight":0};